import React from "react";
import { Breadcrumb } from "semantic-ui-react";
import "moment-timezone";
import { dispatch } from "@rematch/core";
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import _ from "lodash";

class BreadCrumbsPage extends React.Component {
  navigateTo(path) {
    const history = this.props.history;
    dispatch.initiatives.setSelectedDataById({});
    dispatch.initiatives.showResourecePane(null);
    dispatch.initiatives.initiativeAggangementPane(null);
    history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_in${path}`,
    });
  }

  render() {
    let setSelectedActivityData =
      Object.entries(this.props.selectedActivityData).length !== 0 &&
      this.props.selectedActivityData.constructor === Object;
    let selectedInitiative = this.props.selectedDataById;
    // in draft= -1,In-Design = 0,  Active  = 1,  Completed = 2, Closed = 3, in-edit=4, Cancelled=5, onhold= 6
    let subName = null;

    if (selectedInitiative && selectedInitiative.status !== undefined) {
      switch (selectedInitiative.status) {
        case -1:
          subName = "Draft";
          break;
        case 0:
          subName = "In Design";
          break;
        case 1:
          subName = "Active";
          break;
        case 2:
          subName = "Active";
          break;
        case 3:
          subName = "Closed";
          break;
        case 4:
          subName = "Edit Initiative";
          break;
        case 5:
          subName = "Cancelled";
          break;
        case 6:
          subName = "On Hold";
          break;
        default:
          subName = null;
      }
    } else if (this.props.match.params.status) {
      const { status } = this.props.match.params;
      const hasPlaybookData = !_.isEmpty(this.props.selectedPlaybookData);

      switch (status) {
        case "indesign":
          subName = hasPlaybookData ? "Create Initiative" : "In Design";
          break;
        case "active":
          subName = "Active";
          break;
        case "closed":
          subName = "Closed";
          break;
        case "cancelled":
          subName = "Cancelled";
          break;
        case "draft":
          subName = "Draft";
          break;
        default:
          subName = null;
      }
    }

    let breadcrumb;
    if (
      selectedInitiative && selectedInitiative.status !== undefined &&
      this.props.match.params.initiativeId === undefined
    ) {
      breadcrumb =
        subName !== "Create Initiative" || subName !== "Edit Initiative" ? (
          <span>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section 
              onClick={() =>
                this.navigateTo(`/${subName.replace(" ", "").toLowerCase()}`)
              }
            >
              {subName}
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>
              <EllipsisTooltip
                name={selectedInitiative.name}
                position="bottom left"
              />
            </Breadcrumb.Section>
          </span>
        ) : (
          <span>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>{subName}</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>
              <EllipsisTooltip
                name={selectedInitiative.name}
                position="bottom left"
              />
            </Breadcrumb.Section>
          </span>
        );
    } else if (
      this.props.match.params.status &&
      this.props.match.params.initiativeId === undefined
    ) {
      breadcrumb = <span>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>
              {subName}
            </Breadcrumb.Section>
          </span>
    } else if (
      this.props.match.params.status === "indesign" &&
      this.props.match.params.initiativeId === undefined
    ) {
      breadcrumb = (
        <span>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section>Create Initiative</Breadcrumb.Section>
        </span>
      );
    } else if (
      selectedInitiative.status === 0 &&
      this.props.match.params.initiativeId
    ) {
      breadcrumb =
        subName !== "Create Initiative" || subName !== "Edit Initiative" ? (
          <span>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section
              onClick={() =>
                this.navigateTo(`/${subName.replace(" ", "").toLowerCase()}`)
              }
            >
              {subName}
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>
              <EllipsisTooltip
                name={selectedInitiative.name}
                position="bottom left"
              />
            </Breadcrumb.Section>
          </span>
        ) : (
          <span>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>{subName}</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>
              <EllipsisTooltip
                name={selectedInitiative.name}
                position="bottom left"
              />
            </Breadcrumb.Section>
          </span>
        );
    } else if (
      selectedInitiative.status !== 0 &&
      this.props.match.params.initiativeId
    ) {
      breadcrumb = (
        <span>
          <Breadcrumb.Divider icon="right angle" />
          {subName !== "Create Initiative" && subName !== "Edit Initiative" ? (
                <Breadcrumb.Section
                    onClick={() =>
                        this.navigateTo(`/${subName.replace(" ", "").toLowerCase()}`)
                    }
                >
                    {subName}
                </Breadcrumb.Section>
            ) : (
                <Breadcrumb.Section>{subName}</Breadcrumb.Section>
            )}
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section>
            <EllipsisTooltip
              name={selectedInitiative.name}
              position="bottom left"
            />
          </Breadcrumb.Section>
          {setSelectedActivityData &&
          this.props.selectedActivityData &&
          this.props.selectedActivityData.name ? (
            <span>
              <Breadcrumb.Divider icon="right angle" />
              <Breadcrumb.Section>
                <EllipsisTooltip
                  name={
                    this.props.selectedActivityData &&
                    this.props.selectedActivityData.name
                  }
                  position="bottom left"
                />
              </Breadcrumb.Section>
            </span>
          ) : (
            ""
          )}
        </span>
      );
    }
    return (
      <Breadcrumb className="breadCrumbs w_100">
        {(this.props.match.params.status || (selectedInitiative && selectedInitiative.status!== undefined)) ? (
          <Breadcrumb.Section onClick={() => this.navigateTo("")}>
            Initiatives
          </Breadcrumb.Section>
        ) : (
          <Breadcrumb.Section>Initiatives</Breadcrumb.Section>
        )}
        {breadcrumb}
      </Breadcrumb>
    );
  }
}

export default BreadCrumbsPage;
